
  import { mapEntityProperties } from '@/utils/mapEntityProperties'
  import { CancelDeliveryReasonEntity } from '../../domain/entities/CancelDeliveryReasonEntity'
  export class CancelDeliveryReasonModel extends CancelDeliveryReasonEntity {
  constructor(dataDto) {
    super()
    mapEntityProperties(this, dataDto)
  }
}